import { render } from "./ContactBlock.vue?vue&type=template&id=e29a01ea&scoped=true&ts=true"
import script from "./ContactBlock.vue?vue&type=script&lang=ts"
export * from "./ContactBlock.vue?vue&type=script&lang=ts"

import "./ContactBlock.vue?vue&type=style&index=0&id=e29a01ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.9.3__webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29a01ea"]])

export default __exports__